<template>
  <div class="" style="position:fixed">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

  <br>
  <form id="form-upload-document">
        <b-row style="width:100vw">
          <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav">
              <AdminSideNav />
          </b-col>
          <b-col col cols="12" sm="12" md="9" lg="9" style="height:78vh; overflow-y:scroll " class="shadow">
            <b-row>
              <b-col col cols="12" m="12" md="12" lg="12">
               <b-table id="userList"
                responsive
               :per-page="perPage"
               :current-page="currentPage"
                bordered hover small head-variant="dark"
                :items="getUserData" :fields="userFields" style="margin-top:10px;">

                <template v-slot:cell(6)="data">
                 <span v-html="data.value"></span>
                </template>

                </b-table>

               <b-pagination
                 v-model="currentPage"
                 :total-rows="rows"
                 :per-page="perPage"
                 aria-controls="userList"
               ></b-pagination>
               <!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->
             </b-col>
            </b-row>
          </b-col>
      </b-row>
    </form>
      </b-container>
      <br><br>
    </b-overlay>
  </div>
</template>

<script>
import AdminSideNav from '@/components/AdminSideNav.vue'
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex';

//var urlCommon = "https://portald.apdcl.org/website";
var urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var selectedId = null;
var type;

export default {
  name: 'Admin',
  components: {
    'AdminSideNav' : AdminSideNav,
    'HeaderConsumer' : HeaderConsumer,
    'HeaderConsumerMobile' : HeaderConsumerMobile

  },
  data() {
      return {
        userFields: [
          { key: '0', label: 'Id'},
          { key: '1', label: 'Name'},
          { key: '2', label: 'Office'},
          { key: '3', label: 'Designation'},
          { key: '4', label: 'Mobile'},
          { key: '5', label: 'Email'},
          { key: '6', label: 'Active/Deactive'},
          { key: '7', label: 'Creation Date'},
        ],
        getUserData :[],
        perPage: 10,
        currentPage: 1,
        value: '',
        show: false,
         checked: true
      }
    },
    computed:
    {
      // ...mapGetters([
      //   'getUserData'
      // ]),
      rows() {
        return this.getUserData.length
      }

    },

  methods:
  {
    ...mapActions([
      'retrieveContactInfo'
    ]),
    reloadPage()
    {
      window.location.reload();
    },
    f(){
      // alert("hello");
      console.log("function f called");
    }
  },
  mounted()
  {
    var userId = localStorage.getItem("userId");
    var userName = localStorage.getItem("userName");
    var roles = localStorage.getItem("roleSet");
    var temp = [];
    var parent=this;
    if(userId==null)
      {
        this.$router.push({ path: '/' })
        return;
      }
    var i =0;
    var res= roles.split(",");

    for(i=0;i<res.length;i++)
     {
       document.getElementById(res[i]).style.display="block";
     }
     document.getElementById("consName").innerHTML = userName ;
    // var fn=this.f();
     axios.get("http://localhost:8081/website/api/admin/showusers").then(function(response) {
       //parent.getUserData = response.data;
    //   console.log(response.data);
     var temp=[];
     var flag;
     var isChecked;

       response.data.forEach(element => {
         if(element[6]=="Y")
         {
             flag="Active";
             isChecked = "checked"
         }

          else {
            flag="Deactive";
            isChecked = ""
          }
         // console.log(element[0]);
         var obj = {
           "0" : element[0],
           "1" : element[1],
           "2" : element[2],
           "3" : element[3],
           "4" : element[4],
           "6" : "<b-form-checkbox id='checkbox-1' name='check-button' style='border:solid 1px black;'></b-form-checkbox>"+flag,
           // "6" : "<input  type='checkbox' name='check-button' @change='f()' "+isChecked+" /> "+flag,
           "5" : element[5],
           "7" : element[7]
           }
          temp.push(obj);
       })

       parent.getUserData=temp;

     })
  }

}


</script>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
  color: #0097a7 ;
}

li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.shadow{}
  .headerF{
  display: block;
}
.headerM{
  display: none;
}
.sideNav{
  height:75vh;
  overflow-y:auto;
}
.dropdownmenu{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
  @media (max-width: 576px) {
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }


    .path {
      stroke-dasharray: 1000;
      stroke-dashoffset: 0;
    }
    .path.circle {
      -webkit-animation: dash 0.9s ease-in-out;
      animation: dash 0.9s ease-in-out;
    }
    .path.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
      animation: dash 0.9s 0.35s ease-in-out forwards;
    }
    .path.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
      animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }

    p {
      text-align: center;
      margin: 20px 0 60px;
      font-size: 1.25em;
    }
    p.success {
      color: #73AF55;
    }
    p.error {
      color: #D06079;
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @-webkit-keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
    @keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
</style>
